import React from 'react';
import { Button } from 'react-bootstrap';
import { useAuthentication } from './useAuthentication';

const LogOut = () => {
  const { logout } = useAuthentication();

  const handleSubmit = () => {
    logout();
  };

  return (
    <>
      <Button onClick={handleSubmit} variant="secondary" className="mb-1" data-testid="logout">
        Logout
      </Button>
    </>
  );
};

export { LogOut };
